import { Loader2 } from 'lucide-react';
import { cn } from '../../utils/cn';

/**
 * Loading spinner component.
 *
 * @param {Object} props
 * @param {'sm'|'md'|'lg'} [props.size='md'] - Spinner size
 * @param {string} [props.className] - Additional classes
 * @param {string} [props.label] - Accessible label
 */
export function Spinner({
  size = 'md',
  className,
  label = 'Loading',
  ...props
}) {
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  return (
    <div
      role="status"
      aria-label={label}
      className={cn('flex items-center justify-center', className)}
      {...props}
    >
      <Loader2
        className={cn(
          'animate-spin text-primary-600',
          sizes[size]
        )}
      />
      <span className="sr-only">{label}</span>
    </div>
  );
}

/**
 * Full page loading spinner.
 */
export function PageSpinner({ label = 'Loading page' }) {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <Spinner size="lg" label={label} />
    </div>
  );
}

/**
 * Inline loading state with optional text.
 */
export function InlineSpinner({
  size = 'sm',
  text,
  className,
}) {
  return (
    <div className={cn('flex items-center gap-2 text-neutral-600', className)}>
      <Spinner size={size} />
      {text && <span className="text-sm">{text}</span>}
    </div>
  );
}
